import styled from 'styled-components';

const Wrapper = styled.div`
    margin: 0;
    padding: 0 ${props => props.theme.horizontalPadding};
`;

export default Wrapper;
